import { pendingAuthPaymentConfigStore } from "../../../hookstate/pendingAuthPaymentConfigStore";
import {
  persistStripeReturnSlideInMenuState,
  restoreStripeReturnSlideInMenuState,
} from "./stripeReturnSlideInMenu";
import type { PendingAuthPaymentConfigTypes } from "../api/paymentApi";
import type { SessionPayloadStore } from "./sessionPayloadStore";

/**
 * Symmetric save/clear for guest-flow pending purchase state. Each footer must
 * persist three things together (slide-in menu position, Hookstate config,
 * sessionStorage payload) and clear them together — centralising prevents call
 * sites from drifting out of sync.
 */

export function saveGuestPendingPurchase<T extends PendingAuthPaymentConfigTypes>(
  payload: T,
  payloadStore: SessionPayloadStore<T>,
): void {
  persistStripeReturnSlideInMenuState();
  pendingAuthPaymentConfigStore.set(payload);
  payloadStore.persist(payload);
}

export function clearGuestPendingPurchase<T>(
  payloadStore: SessionPayloadStore<T>,
): void {
  pendingAuthPaymentConfigStore.set(undefined);
  payloadStore.clear();
  restoreStripeReturnSlideInMenuState();
}
